import { AxiosInstance } from 'axios';
import { IEditableVoter, IVoter } from '../models';

export class VoterClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/voter`;
    }

    public async update(voterIdentifier: string, editable: IEditableVoter): Promise<IVoter> {

        try {

            const response = await this.axiosClient.put(
                `${this.apiUrl}/${voterIdentifier}`,
                editable
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
